import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useSession } from "@/services/auth";

interface PaymentEligibility {
  eligible: boolean;
  reason: string | null;
  message: string | null;
  amountCents: number;
  allowInvoice: boolean;
}

export function useOrderPaymentEligibility(orderId: string, open: boolean) {
  const { token, customer } = useSession();
  return useQuery({
    queryKey: ["orderPaymentEligibility", customer?.id, orderId],
    queryFn: async () => {
      const { data } = await axios.get<{
        paymentEligibility: PaymentEligibility;
      }>(
        `${import.meta.env.VITE_API_URL}/api/v2/orders/${orderId}/payment-status`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!data.paymentEligibility)
        throw new Error("Payment eligibility unavailable");
      return data.paymentEligibility;
    },
    enabled: open && !!token,
    retry: false,
    staleTime: 0,
  });
}
